// extracted by mini-css-extract-plugin
export default {"box":"ElectricityBillBasicCharge_box__NaChF","boxBorder":"ElectricityBillBasicCharge_boxBorder__qB2L6"};